import { HarmonicQuestion } from '../../types/harmonic';

export const harmonicQuestionsTR: HarmonicQuestion[] = [
  // Seviye 1: İlgisizlik (Apathy)
  { id: 'apathy1', levelId: 1, text: 'Kendimi sık sık hedeflerimden ve hayallerimden tamamen kopmuş hissederim.', reversed: false },
  { id: 'apathy2', levelId: 1, text: 'Durumların nasıl sonuçlanacağını önemsemekte zorlanırım.', reversed: false },
  { id: 'apathy3', levelId: 1, text: 'Hayatımdaki önemli konulara karşı tamamen kayıtsız hissettiğim pek olmaz.', reversed: true },

  // Seviye 2: Umutsuzluk (Hopelessness)
  { id: 'hopeless1', levelId: 2, text: 'Mevcut koşullarımı değiştirmek konusunda kendimi güçsüz hissederim.', reversed: false },
  { id: 'hopeless2', levelId: 2, text: 'İçinde bulunduğum durumda iyileşme olasılığı görmekte zorlanırım.', reversed: false },
  { id: 'hopeless3', levelId: 2, text: 'Küçük adımların tamamen anlamsız olduğuna çok zaman inanmam.', reversed: true },

  // Seviye 3: Keder (Grief)
  { id: 'grief1', levelId: 3, text: 'Kaybettiklerim ve kaçırdıklarım hakkında çok fazla düşünürüm.', reversed: false },
  { id: 'grief2', levelId: 3, text: 'Geçmiş deneyimlerim üzerine düşündüğümde derin bir üzüntü hissederim.', reversed: false },
  { id: 'grief3', levelId: 3, text: 'Geçmişte yaşadığım hayal kırıklıkları üzerinde düşünüp, takılı kalmış hissettiğim pek olmaz.', reversed: true },

  // Seviye 4: Korku (Fear)
  { id: 'fear1', levelId: 4, text: 'Olası olumsuz sonuçlar nedeniyle harekete geçmekte sık sık tereddüt ederim.', reversed: false },
  { id: 'fear2', levelId: 4, text: 'Nelerin ters gidebileceğini analiz etmeye çok zaman harcarım.', reversed: false },
  { id: 'fear3', levelId: 4, text: 'Belirsiz durumlarla başa çıkamayacak kadar yetersiz hissettiğim nadiren olur.', reversed: true },

  // Seviye 5: Pasif Düşmanlık (Passive Hostility)
  { id: 'passive1', levelId: 5, text: 'Katılmadığımı doğrudan ifade etmek yerine dolaylı biçimde direnç gösteririm.', reversed: false },
  { id: 'passive2', levelId: 5, text: 'Memnuniyetsizliğimi ifade etmek için iğneleyici ya da imalı sözler kullanırım.', reversed: false },
  { id: 'passive3', levelId: 5, text: 'Çekincelerimi doğrudan ifade etmekten genellikle kaçarım.', reversed: true },

  // Seviye 6: Açık Öfke (Open Anger)
  { id: 'anger1', levelId: 6, text: 'İşler beklentilerimi karşılamadığında yaşadığım hayal kırıklığını doğrudan ifade ederim.', reversed: false },
  { id: 'anger2', levelId: 6, text: 'Adaletsizlik olarak gördüğüm durumlara anında ve güçlü tepki veririm.', reversed: false },
  { id: 'anger3', levelId: 6, text: 'Zor durumlarda yaşadığım hayal kırıklığının tepkilerimi tamamen kontrol etmesine nadiren izin veririm.', reversed: true },

  // Seviye 7: Karşı Koyma (Antagonism)
  { id: 'antag1', levelId: 7, text: 'Başkalarının fikirlerini sık sık sorgular ya da onların fikirlerine karşı çıkarım.', reversed: false },
  { id: 'antag2', levelId: 7, text: 'Planlardaki veya önerilerdeki eksikliklere dikkat çekme eğilimindeyim.', reversed: false },
  { id: 'antag3', levelId: 7, text: 'Karşıt görüşleri, üzerinde düşünmeden peşinen reddetmem.', reversed: true },

  // Seviye 8: Rasyonel Tarafsızlık (Rational Neutrality)
  { id: 'neutral1', levelId: 8, text: 'Zorluklara sakin ve mantıklı bir bakış açısıyla yaklaşırım.', reversed: false },
  { id: 'neutral2', levelId: 8, text: 'Sorunları çözerken duygusal dengemi koruyabilirim.', reversed: false },
  { id: 'neutral3', levelId: 8, text: 'Duygularımın, mantıklı düşünmemin tamamen önüne geçmesine nadiren izin veririm.', reversed: true },

  // Seviye 9: İlgi (Interest)
  { id: 'interest1', levelId: 9, text: 'Yeni bakış açılarını öğrenmeye ve anlamaya aktif olarak çaba gösteririm.', reversed: false },
  { id: 'interest2', levelId: 9, text: 'Sohbetlere ve tartışmalara hevesle katılırım.', reversed: false },
  { id: 'interest3', levelId: 9, text: 'Alışık olmadığım fikirleri, üzerinde düşünmeden peşinen reddetmem.', reversed: true },

  // Seviye 10: İyimserlik (Optimism)
  { id: 'optimism1', levelId: 10, text: 'Zorlu durumlarda sürekli fırsatları görmeye çalışırım.', reversed: false },
  { id: 'optimism2', levelId: 10, text: 'Aksiliklere rağmen olumlu sonuçlara olan inancımı korurum.', reversed: false },
  { id: 'optimism3', levelId: 10, text: 'Engellerle karşılaştığımda kendimi tamamen umutsuz hissettiğim nadiren olur.', reversed: true },

  // Seviye 11: Coşku (Enthusiasm)
  { id: 'enthus1', levelId: 11, text: 'Fikirlerimi paylaşmak ve başkalarıyla iş birliği yapmak bana enerji verir.', reversed: false },
  { id: 'enthus2', levelId: 11, text: 'Tutkum ve heyecanımla başkalarına ilham veririm.', reversed: false },
  { id: 'enthus3', levelId: 11, text: 'Bir zamanlar ilgi çekici bulduğum projelere karşı tüm hevesimi nadiren kaybederim.', reversed: true },

  // Seviye 12: Coşkunluk (Exhilaration)
  { id: 'exhil1', levelId: 12, text: 'Yaptığım işlerde saf bir mutluluk ve bütünlük hissi içinde olma anları yaşarım.', reversed: false },
  { id: 'exhil2', levelId: 12, text: 'Derin bir doyum ve anlam duygusu hissederim.', reversed: false },
  { id: 'exhil3', levelId: 12, text: 'Günlük hayatımda hiç keyif bulamadığım pek olmaz.', reversed: true }
];
